export default {
  directives: {
    currency: {
      bind: function(el, binding, vnode) {
        // console.log('bind', el, binding, vnode)
        switch (binding.value) {
          case 'uk':
            vnode.elm.innerText = '£'
            break
          case 'us':
            vnode.elm.innerText = '$'
            break
          default:
            vnode.elm.innerText = '£'
            break
        }
      }
      // inserted: function(el, binding, vnode) {
      //   // console.log('inserted: ', el, binding, vnode)
      // },
      // update: function(el, binding, vnode) {
      //   // console.log('update: ', el, binding, vnode)
      // },
      // componentUpdated: function(el, binding, vnode) {
      //   // console.log('componentUpdated: ', el, binding, vnode)
      // },
      // unbind: function(el, binding, vnode) {
      //   // console.log('unbind: ', el, binding, vnode)
      // }
    }
  }
}
